import { type AiFeedbackProps } from "./types";
import MadFeedback from "../MadFeedback/MadFeedback";

/**
 * `AiFeedback` is a component that renders feedback options for a specific AI-generated message.
 * It uses the `MadFeedback` component under the hood, pre-configured with the appropriate domain and lookup data for AI feedback.
 * @internal
 */
export function AiFeedback({
  session,
  message,
  clientKey,
  agent,
  ...feedbackProps
}: AiFeedbackProps) {
  return (
    <MadFeedback
      {...feedbackProps}
      domain="Maverick Agent"
      data={{
        agent,
        clientKey: clientKey,
        sessionId: session.id,
        messageId: message.id,
        messageAuthor: message.author,
        messageRole: message.role,
        messageConfidence: message.confidence?.toString() || ""
      }}
    />
  );
}
